import { z } from 'zod';
import { clientRequestIdSchema, instantSchema, localDateSchema, objectIdSchema, timezoneSchema, } from './common.js';
/**
 * Water intake.
 *
 * Stored as timestamped millilitre entries, mirroring weight, so the same
 * timezone-aware daily rollup applies: a glass logged at 23:30 counts toward
 * the day the user experienced, not UTC's.
 */
export const waterMlSchema = z.number().int().min(1).max(5000);
export const addWaterSchema = z.object({
    ml: waterMlSchema,
    loggedAt: instantSchema.optional(),
    /** Present when the write came from the offline queue. */
    clientRequestId: clientRequestIdSchema.optional(),
});
export const waterEntrySchema = z.object({
    id: objectIdSchema,
    ml: z.number().int(),
    loggedAt: z.string(),
});
export const waterDayQuerySchema = z.object({
    date: localDateSchema.optional(),
    timezone: timezoneSchema.optional(),
});
export const waterDaySchema = z.object({
    date: localDateSchema,
    /** Sum for the day, in millilitres. */
    totalMl: z.number().int(),
    goalMl: z.number().int().nullable(),
    entries: z.array(waterEntrySchema),
});
//# sourceMappingURL=water.js.map